import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { FormClientAFY } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import LocalStorageService from "../../../services/localStorage";
import { getInfo } from "../../../services/functions";
import { hasPermission } from "../../../services/getNavigationPages";
import { useTranslation } from "react-i18next";
export var CustomerFormsView = function (props) {
    var _a, _b, _c, _d;
    var t = useTranslation().t;
    var storageKey = "afy-steps";
    var localStorageService = new LocalStorageService(storageKey);
    var _e = useState({
        Id: "",
        IdType: "",
        Type: "",
        DocumentNumber: "",
        Name: "",
        LastName: "",
        MarriedSurName: "",
        Gender: "",
        Birthday: "",
        Country: "",
        Province: "",
        Town: "",
        Sector: "",
        PostalCode: "",
        Address1: "",
        Address2: "",
        PhoneOffice: "",
        PhoneHome: "",
        PhoneNumber: "",
        Email: "",
    }), dataForm = _e[0], setDataForm = _e[1];
    var _f = React.useState({
        id: ((_b = (_a = getInfo("steps", "Productos")) === null || _a === void 0 ? void 0 : _a.details) === null || _b === void 0 ? void 0 : _b.projectId) || "1",
        name: ((_d = (_c = getInfo("steps", "Productos")) === null || _c === void 0 ? void 0 : _c.details) === null || _d === void 0 ? void 0 : _d.title) || "NA",
    }), plan = _f[0], setPlan = _f[1];
    var onAcquire = function (item) {
        setPlan(item);
        if (props.onAcquire) {
            props.onAcquire(item);
        }
    };
    useEffect(function () {
        if (props.dataForm) {
            setDataForm({
                // Id: props.dataForm.id,
                IdType: props.dataForm.IdType,
                Type: props.dataForm.Type,
                DocumentNumber: props.dataForm.DocumentNumber,
                Name: props.dataForm.Name,
                SecondName: props.dataForm.SecondName,
                //FirstLastName: props.dataForm.FirstLastName,
                //SecondLastName: props.dataForm.SecondLastName,
                MarriedSurName: props.dataForm.MarriedSurName,
                Gender: props.dataForm.Gender,
                Birthday: props.dataForm.Birthday,
                Country: props.dataForm.Country,
                Province: props.dataForm.Province,
                Town: props.dataForm.Town,
                Sector: props.dataForm.Sector,
                PostalCode: props.dataForm.PostalCode,
                Address1: props.dataForm.Address1,
                Address2: props.dataForm.Address2,
                PhoneOffice: props.dataForm.PhoneOffice,
                PhoneHome: props.dataForm.PhoneHome,
                PhoneNumber: props.dataForm.PhoneNumber,
                Email: props.dataForm.Email,
            });
        }
    }, [props.dataForm]);
    var foundPerson = !props.showClientActions;
    return (_jsx(FormClientAFY, { hideChangePlan: props.hideChangePlan, isRequired: !props.isApap, hideButtonChangeCampaing: props.hideButtonChangeCampaing, nextDisabled: !hasPermission("sale-customer-form-create"), dynamicFilter: true, titleFilter: "Resumen", 
        // title="Validar cliente"
        minHeightGrid: "calc(100vh - 146px)", onBlurInput: props.handleOnBlur, hideMarriedName: props.hideMarriedName, onChangeInput: function () { }, onNext: props.handleSubmit, onBack: props.handleBack, stepProgress: props.stepProgress, TypeList: props.TypeList, GenderList: props.GenderList, CountryList: props.CountryList, onChangeOptions: props.onChangeOptions, onChangeSelect: props.onChangeSelect, ProvinceList: props.ProvinceList, titleSelectButton: t("customer.selectButton"), TownList: props.TownList, SectorList: props.SectorList, dataForm: props.dataForm, plans: props.plans, hide1: props.hide1, hide2: props.hide2, hide3: props.hide3, insuranceLabel: props.insuranceLabel, insuranceValue: props.insuranceValue, options1: props.options1, options2: props.options2, options3: props.options3, formsCompleted: [foundPerson, false, false], plan: plan, showPaymentMethod: props.showPaymentMethod, paymentMethodData: props.paymentMethodData, onChangePaymentMethod: props.clickChangePaymentMode, onChangeCoverType: props.onChangeCoverType, onClickAcquire: onAcquire, disableSelectCountry: true, disableDocumentType: true, disableFields: true, disableNameFields: props.disableNameFields, modalPadding: 20, filters: props.filters, showClientActions: props.showClientActions, editClientMode: props.editClientMode }));
};
